import React from 'react'
import { useEffect } from 'react'
import axios from "axios"
import { useState } from 'react'
import {useParams} from "react-router-dom"
const ClientReply = () => {
  const {id}=useParams()
  const [clientInfo,setClientInfo]=useState(null)
  useEffect(()=>{
axios
  .get("https://back.waratechnology.com/api/client/getclientinfo/" + id)
  .then((res) => {
    console.log(res.data.data);
    setClientInfo(res.data.data);
  })
  .catch((err) => {
    console.log(err.response.data.msg);
  });
  },[])
  const handleReply=()=>{

  }
  return (
    <div className='flex justify-center items-center h-screen bg-gray-400'>
      ,<div className='w-1/2 h-3/4 bg-white p-3 rounded-xl'> 
        <form className='flex text-start font-bold flex-col gap-2' onSubmit={handleReply}>
          <label htmlFor="">Reciever Name</label><input className='border-stone-200 border-2  outline-orange-500 p-1 rounded-xl' type="text"  />
          <label htmlFor="">Reciever Email</label><input className='border-stone-200 border-2  outline-orange-500 p-1 rounded-xl' type="email" />
          <label htmlFor="">Subject</label><input className='border-stone-200 border-2  outline-orange-500 p-1 rounded-xl' type="text" />
          <label htmlFor="">Message</label><input className='border-stone-200 border-2  outline-orange-500 p-1 rounded-xl' type="text" />
          <button className='py-1 mt-4 text-white bg-blue-500 hover:bg-blue-700 w-full' type='submit'>Reply</button>
        </form>
      </div>
    </div>
  )
}

export default ClientReply
